// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".azati-vwc-blog-bottom-form{margin:0 auto}.azati-vwc-blog-bottom-form .button-wrapper{display:flex;align-items:center;justify-content:space-between;margin-top:20px}.azati-vwc-blog-bottom-form .button-wrapper .azati-vwc-button{min-width:180px}@media screen and (max-width:619.88px){.azati-vwc-blog-bottom-form .button-wrapper{flex-direction:column-reverse}.azati-vwc-blog-bottom-form .button-wrapper .azati-vwc-form-alert{width:100%;margin-right:0;margin:10px 0}}", ""]);
// Exports
module.exports = exports;
